// extracted by mini-css-extract-plugin
export default {"no-auth":"style_no-auth__dbE+0","no-auth-img":"style_no-auth-img__o9UA4","no-auth-text":"style_no-auth-text__Kn0Wy"};